import {
	Card,
	CardContent,
	CardDescription,
	CardHeader,
	CardTitle,
} from "@/components/ui/card";
import {
	Trophy,
	Users,
	Laptop,
	Network,
	LightbulbIcon,
	GraduationCap,
} from "lucide-react";

const Benefits: React.FC = () => {
	const benefits = [
		{
			id: "prize",
			title: "賞金・賞品",
			description: "優秀なプロジェクトには賞金が授与されます",
			icon: Trophy,
			points: ["グランプリ：30万円", "準グランプリ：15万円", "各種企業賞"],
		},
		{
			id: "networking",
			title: "ネットワーキング",
			description: "様々な参加者との交流機会",
			icon: Network,
			points: ["地域企業との接点", "メンターとの出会い", "チームメイトとの絆"],
		},
		{
			id: "learning",
			title: "学習機会",
			description: "新しいスキルの習得",
			icon: GraduationCap,
			points: ["実践的な開発経験", "最新技術の活用", "プレゼンスキル"],
		},
		{
			id: "support",
			title: "開発サポート",
			description: "充実したサポート体制",
			icon: Users,
			points: ["技術メンタリング", "環境構築支援", "デザインレビュー"],
		},
		{
			id: "environment",
			title: "開発環境",
			description: "快適な開発環境を提供",
			icon: Laptop,
			points: ["高速Wi-Fi", "電源完備", "開発ツール提供"],
		},
		{
			id: "innovation",
			title: "イノベーション創出",
			description: "新しいアイデアの実現",
			icon: LightbulbIcon,
			points: ["地域課題への取り組み", "ビジネス化支援", "継続的なフォロー"],
		},
	];

	return (
		<section className="py-16 bg-gray-50">
			<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
				<h2 className="text-3xl font-bold mb-4 text-center">参加メリット</h2>
				<p className="text-gray-600 text-center mb-12">
					ハッカソン参加で得られる価値
				</p>
				<div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
					{benefits.map((benefit) => (
						<Card key={benefit.id}>
							<CardHeader>
								<div className="flex items-center gap-3">
									<benefit.icon className="w-6 h-6 text-purple-600" />
									<CardTitle>{benefit.title}</CardTitle>
								</div>
								<CardDescription>{benefit.description}</CardDescription>
							</CardHeader>
							<CardContent>
								<ul className="list-disc list-inside space-y-2 text-sm text-gray-600">
									{benefit.points.map((point) => (
										<li key={point}>{point}</li>
									))}
								</ul>
							</CardContent>
						</Card>
					))}
				</div>
			</div>
		</section>
	);
};

export default Benefits;
